import * as React from "react";
import { Button, Menu, Dropdown, Icon } from "antd";

export interface State {}

export interface Props {
  translate: any;
  onRemoveBtnClick: any;
  addAttributeBtnClick: any;
}

export default class QualifierActionsBar extends React.Component<Props, State> {
  get menu() {
    const { translate, onRemoveBtnClick, addAttributeBtnClick } = this.props;

    return (
      <Menu>
        <Menu.Item key="1" onClick={addAttributeBtnClick}>
          {translate("qualifier_actions_bar.add_attribute")}
        </Menu.Item>
        <Menu.Item key="3" onClick={onRemoveBtnClick} style={{ color: "red" }}>
          {translate("qualifier_actions_bar.remove")}
        </Menu.Item>
      </Menu>
    );
  }

  render() {
    const { translate } = this.props;

    return (
      <Dropdown overlay={this.menu}>
        <Button>
          {translate("form_section_actions_bar.actions_label")}{" "}
          <Icon type="down" />
        </Button>
      </Dropdown>
    );
  }
}
